import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable, throwError } from "rxjs";
import { map, tap } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { NotificationService } from "../../services/notification.service";
import { Permission } from "./permission.interface";

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  constructor(
    private http: HttpClient,
    private notificationService: NotificationService
  ) { }

  addPermission(request): Observable<Permission> {
    return this.http.post(`${environment.DASHBOARD_PRIVATE_BASE_URL}/aggiungiPermesso`, request)
      .pipe(
        tap(risposta => {
          if (risposta['codice'] !== '000') {
            throwError("Si è verificato un errore in fase di aggiunta del permesso.");
          }
        }),
        map(response => response['response'].permesso),
      )
  }
  updatePermission(request): Observable<Permission> {
    return this.http.post(`${environment.DASHBOARD_PRIVATE_BASE_URL}/aggiornaPermesso`, request)
      .pipe(
        tap(risposta => {
          if (risposta['codice'] !== '000') {
            throwError("Si è verificato un errore in fase di modifica del permesso.");
          }
        }),
        map(response => request),
      )
  }
  removePermission(idPermesso: string): Observable<string> {
    return this.http.get(`${environment.DASHBOARD_PRIVATE_BASE_URL}/eliminaPermesso/${idPermesso}`).pipe(
      tap(risposta => {
        if (risposta['codice'] !== '000') {
          throwError("Si è verificato un errore in fase di rimozione di un permesso")
        }
        this.notificationService.setNotification('Permesso cancellato con successo.');
      }),
      map(() => idPermesso)
    )
  }
}
